<template>
	<div class="c-script-page" v-if="isAuth">
		<Script></Script>
	</div>
</template>

<script>
import Script from '@swipekit/components/script';

export default {
	components: {
		Script,
	},

	computed: {
		isAuth: function () {
			return this.$store.getters['users/isAuth'];
		},
	},
};
</script>

<style lang="scss">
.c-script-page {
}
</style>
